import { render, staticRenderFns } from "./TickerDetail.vue?vue&type=template&id=774a1a8a&scoped=true"
import script from "./TickerDetail.vue?vue&type=script&lang=js"
export * from "./TickerDetail.vue?vue&type=script&lang=js"
import style0 from "./TickerDetail.vue?vue&type=style&index=0&id=774a1a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a1a8a",
  null
  
)

export default component.exports